import request from '@/utils/request'

/** 证书查询
 * @param {*} data{} 
 * @param {*} param             身份证号码或者证书编号
 * @param {*} type              证书类型
 */
export function getCertInfo (data) {
  return request({
    url: 'cert/getCertInfo',
    method: 'get',
    params: data
  })
}

/** 成绩查询
 * @param {*} data{} 
 * @param {*} idNumber          身份证号码
 * @param {*} type              证书类型
 * @returns 
 */
export function getUserScore (data) {
  return request({
    url: 'cert/getUserScore',
    method: 'get',
    params: data
  })
}
